import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * 求職者タグを削除するフック
 */
export default function useDeleteCandidateTag() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (id: number) => {
      const response = await fetch(`/agent/api/custom_tags/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to delete tag');
      }

      return response.json();
    },
    onSuccess: () => {
      // タグ一覧を再取得
      queryClient.invalidateQueries({
        queryKey: ['/agent/api/candidate_profile_tags'],
      });
    },
  });
}
